import { TransformFormatType } from '../../../../models/ITransform';

export const defaultTransformColumnFormat = 'text';

export const transformFormats: { value: TransformFormatType, label: string }[] = [
    { value: 'response', label: 'response' },
    { value: 'markdown', label: 'markdown' },
    { value: 'javascript', label: 'javascript' },
    { value: 'text', label: 'text' },
    { value: 'html', label: 'html' },
    { value: 'json', label: 'json' },
];

const threeModesEditor = {
    editor: true,
    both: true,
    preview: true,
};

//  If editor has different preview modes like editor/both/preview,
//  the map below should be updated
export const transformFormatsEditorModes = {
    text: {},
    json: {},
    javascript: {},
    response: threeModesEditor,
    html: threeModesEditor,
    markdown: threeModesEditor
};

export function getTransformFormatsByCellType(format: TransformFormatType, name: string) {
    if (name === 'result') {
        return transformFormats;
    }
    if (name !== 'result' && format === 'response') {
        return transformFormats.map(format => ({ ...format, disabled: format.value === 'response' }));
    }
    return transformFormats.filter(format => format.value !== 'response');
}